import React, { Component } from "react";
import arrowRight from "../img/right-arrow.svg";
import arrowLeft from "../img/left-arrow.svg";
import ecommerceData from "../ecommerceData.json";

export default class Ecommerce extends Component {
  render() {
    return (
      <div>
        <div className="website">
          <div className="container">
            <div className="website__content website-content">
              <div className="title">
                <div className="title__img">
                  <img src={arrowLeft} height="25px" alt="arrow right" />
                </div>
                <div className="title__heading">
                  <h1>E-commerce websites</h1>
                </div>
                <div className="title__img">
                  <img src={arrowRight} height="25px" alt="arrow right" />
                </div>
              </div>
              {ecommerceData.map((ecommerceItem, index) => {
                return (
                  <div key={index} className="website-content__item">
                    <div className="website__info">
                      <span className="website__date">
                        {ecommerceItem.date}
                      </span>
                      <span className="website__name">
                        Web site name:{" "}
                        <span className="website__name--text">
                          {ecommerceItem.name}
                        </span>
                      </span>
                      <p className="website__desc">{ecommerceItem.text}</p>
                      <div className="tags">
                        Tags:
                        {ecommerceItem.tags.map((tag, index) => {
                          return (
                            <span key={index} className="tags__item">
                              {tag}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                    <div className="website__screen">
                      <a
                        href={ecommerceItem.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={ecommerceItem.img} alt="tajam" />
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
